module.exports = __webpack_public_path__ + "media/images/ir/profile/photo_takahashi-d058501679d8139e85760b135d06fb63.jpg";